import React, { useState, useEffect } from 'react';
import { Modal, Typography, Divider, Spin, App, Space, Card } from 'antd';
import { deviceRegisterService } from '../services/posApi';

const { Title, Text } = Typography;

const ShiftInfoModal = ({ visible, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [shiftData, setShiftData] = useState(null);
    const { message: messageApi } = App.useApp();

    // Получение cashRegisterId из localStorage
    const getCashRegisterId = () => {
        try {
            const deviceInfo = JSON.parse(localStorage.getItem('device_register_info') || '{}');
            return deviceInfo.cash_register?.id;
        } catch (error) {
            console.error('Ошибка получения cashRegisterId:', error);
            return null;
        }
    };

    // Форматирование даты
    const formatDate = (dateString) => {
        try {
            const date = new Date(dateString);
            const months = [
                'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
                'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
            ];

            const day = date.getDate();
            const month = months[date.getMonth()];
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');

            return `Обновлено ${day} ${month} в ${hours}:${minutes}`;
        } catch (error) {
            console.error('Ошибка форматирования даты:', error);
            return 'Дата не определена';
        }
    };

    // Загрузка данных о смене
    const loadShiftInfo = async () => {
        const cashRegisterId = getCashRegisterId();

        if (!cashRegisterId) {
            messageApi.error('Не удалось получить ID кассы');
            return;
        }

        setLoading(true);
        try {
            const response = await deviceRegisterService.getShiftInfo(cashRegisterId);

            if (response.status === 'success') {
                setShiftData(response.data);
            } else {
                messageApi.error('Ошибка при получении данных о смене');
            }
        } catch (error) {
            console.error('Ошибка загрузки информации о смене:', error);
            messageApi.error('Не удалось загрузить информацию о смене');
        } finally {
            setLoading(false);
        }
    };

    // Загрузка данных при открытии модала
    useEffect(() => {
        if (visible) {
            loadShiftInfo();
        }
    }, [visible]);

    // Сброс данных при закрытии модала
    const handleClose = () => {
        setShiftData(null);
        onClose();
    };

    return (
        <Modal
            title="Информация о смене"
            open={visible}
            onCancel={handleClose}
            footer={null}
            width={400}
            centered
        >
            {loading ? (
                <Space
                    direction="vertical"
                    size="large"
                    style={{ width: '100%', textAlign: 'center', padding: '40px 0' }}
                >
                    <Spin size="large" />
                </Space>
            ) : shiftData ? (
                <Space direction="vertical" size="large" style={{ width: '100%' }}>
                    {/* Дата обновления */}
                    <Text type="secondary" style={{ fontSize: '14px' }}>
                        {formatDate(shiftData.date_time)}
                    </Text>

                    {/* Общая сумма продаж */}
                    <Title level={3} style={{ margin: 0, fontSize: '24px', fontWeight: 600 }}>
                        {parseFloat(shiftData.total_sales).toLocaleString()} ₸
                    </Title>

                    {/* Методы оплаты */}
                    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                        {shiftData.payment_methods.map((method) => (
                            <Card
                                key={method.payment_method_id}
                                size="small"
                                bordered={false}
                                style={{ backgroundColor: 'var(--ant-color-fill-tertiary)' }}
                            >
                                <Space direction="vertical" size="small" style={{ width: '100%' }}>
                                    <Text type="secondary" style={{ fontSize: '16px', fontWeight: 500 }}>
                                        {method.payment_method_name}
                                    </Text>

                                    <Divider style={{ margin: '8px 0' }} />

                                    <Space direction="vertical" size="small" style={{ width: '100%' }}>
                                        {/* Валовые платежи */}
                                        <Space style={{ width: '100%', justifyContent: 'space-between' }}>
                                            <Text style={{ fontSize: '14px' }}>
                                                Продажи
                                            </Text>
                                            <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                {parseFloat(method.sales_sum).toLocaleString()} ₸
                                            </Text>
                                        </Space>

                                        {/* Возвраты */}
                                        <Space style={{ width: '100%', justifyContent: 'space-between' }}>
                                            <Text style={{ fontSize: '14px' }}>
                                                Возвраты
                                            </Text>
                                            <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                {parseFloat(method.refunds_sum).toLocaleString()} ₸
                                            </Text>
                                        </Space>

                                        {/* Чистые платежи */}
                                        <Space style={{ width: '100%', justifyContent: 'space-between' }}>
                                            <Text style={{ fontSize: '14px' }}>
                                                Чистые платежи
                                            </Text>
                                            <Text style={{ fontSize: '14px', fontWeight: 600 }}>
                                                {parseFloat(method.net_sum).toLocaleString()} ₸
                                            </Text>
                                        </Space>
                                    </Space>
                                </Space>
                            </Card>
                        ))}
                    </Space>
                </Space>
            ) : (
                <Space
                    direction="vertical"
                    size="large"
                    style={{ width: '100%', textAlign: 'center', padding: '40px 0' }}
                >
                    <Text type="secondary">Нет данных для отображения</Text>
                </Space>
            )}
        </Modal>
    );
};

export default ShiftInfoModal;